<div class="chevron-vertical-body" [ngClass]="{'chevron-vertical-highlight': highlight}" [style]="'min-height: ' + minHeight">
  <svg class="chevron-vertical-head" viewBox="0 0 10 20" preserveAspectRatio="none">
    <path d="
          M  0 20
          V     2
          L  5 18
          L 10  2
          V    20
          " stroke-width="1" />
  </svg>
  <svg class="chevron-vertical-middle" viewBox="0 0 10 10" preserveAspectRatio="none">
    <rect x="0" y="0" width="10" height="10" stroke-width="0" />
    <path d="
          M  0  0
          V    10
          " stroke-width="1" />
    <path d="
          M 10  0
          V    10
          " stroke-width="1" />
  </svg>
  <svg class="chevron-vertical-tail" viewBox="0 0 10 20" preserveAspectRatio="none">
    <path d="
          M  0  0
          L  5 18
          L 10  0
          " stroke-width="1" />
  </svg>
  <div class="chevron-vertical-label" [style]="'font-size: ' + fontSize" innerHTML="{{label}}"></div>
</div>
